module.exports = __webpack_public_path__ + "img/tools-info-slides.b0b3412d.png";